import { render, staticRenderFns } from "./Birthdays.vue?vue&type=template&id=57dfe7a8&scoped=true&"
import script from "./Birthdays.vue?vue&type=script&lang=js&"
export * from "./Birthdays.vue?vue&type=script&lang=js&"
import style0 from "./Birthdays.vue?vue&type=style&index=0&id=57dfe7a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57dfe7a8",
  null
  
)

export default component.exports